import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import MeetingAvtor from '../MeetingAvtor'
import DateAvtor from '../DateAvtor'

const MeetingContainerAvtor = ({ getChats, userName, getMessages, getMeeting }) => {
  const { chatUser } = useSelector(({ chat }) => chat)
  const [open, setOpen] = useState(false)

  return (
    <>
      {
        chatUser?.status !== 'request' && chatUser?.uuid && !chatUser?.meeting?.uuid && (
          <DateAvtor getMessages={getMessages} getChats={getChats} name={userName(chatUser?.authorUuid)} newTitle />
        )
      }
      {
        chatUser?.status !== 'request' && chatUser?.uuid && chatUser?.meeting?.uuid && chatUser?.meeting?.start && (
          open ? (
            <DateAvtor
              onEddit
              setOpen={setOpen}
              getChats={getChats}
              getMessages={getMessages}
              name={userName(chatUser?.authorUuid)}
              getMeeting={getMeeting}
              newTitle
              newDate={+chatUser?.meeting?.start}
            />
          ) : (
            chatUser?.meeting?.status === 'declined' ? (
              <DateAvtor
                onEddit
                setOpen={setOpen}
                getChats={getChats}
                getMessages={getMessages}
                name={userName(chatUser?.authorUuid)}
                getMeeting={getMeeting}
                newTitle
                newDate={+chatUser?.meeting?.start}
              />
            ) : chatUser?.meeting?.status === 'accepted' && chatUser?.status === 'meeting' && chatUser?.uuid ? (
              <DateAvtor getMessages={getMessages} getChats={getChats} name={userName(chatUser?.authorUuid)} newTitle />
            ) : (
              <MeetingAvtor setOpen={setOpen} />
            )
          )
        )
      }
    </>
  )
}

export default MeetingContainerAvtor
